import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config/config";

// Fixed display order for the home page recognitions grid. Matching is done on
// a normalized title (case-, whitespace-, and punctuation-insensitive) so stray
// spacing in the CMS data does not break the ordering.
const DESIRED_ORDER = [
  "ISP Connected at Most Locations of NIXI",
  "Data Center Partner of the Year, 2026",
  "ET Edge Award for Saksham Cloud",
  "Fortinet 2025 SELECT Partner Award",
  "Deloitte Fast 50",
  "CIO Choice 2024- Telecom Leased Line",
  "Ishan Wins Frost & Sullivan Award for Network Services",
  "Versatility MSP- Business Velocity Award 2025",
];

const normalizeTitle = (title) =>
  (title || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();

const DESIRED_ORDER_INDEX = new Map(
  DESIRED_ORDER.map((title, index) => [normalizeTitle(title), index])
);

const getOrderIndex = (title) => {
  const index = DESIRED_ORDER_INDEX.get(normalizeTitle(title));
  return index === undefined ? Number.MAX_SAFE_INTEGER : index;
};

export default function Recognitions() {
  const [awards, setAwards] = useState([]);

  useEffect(() => {
    axios
      .post(`${API_BASE_URL}/api/aboutus/getAboutUs`, { service_tag: "about" })
      .then((response) => {
        const data =
          response?.data?.data?.about_us?.about_us_recognitions_data || [];
        setAwards(data);
      })
      .catch(() => {
        setAwards([]);
      });
  }, []);

  if (awards.length === 0) {
    return null;
  }

  // Show 8 awards in the fixed DESIRED_ORDER above. Any award not in that list
  // falls back to the end, newest (highest id) first.
  const visibleAwards = [...awards]
    .sort((a, b) => {
      const orderDiff = getOrderIndex(a.title) - getOrderIndex(b.title);
      if (orderDiff !== 0) return orderDiff;
      return (b.id || 0) - (a.id || 0);
    })
    .slice(0, 8);

  return (
    <div className="home-recognitions section-space">
      <div className="container">
        <div className="home-recognitions__head">
          <h2 className="home-recognitions__heading">
            Recognitions &amp; Awards 
          </h2>
          <p className="home-recognitions__subtitle">
            25 years of excellence, recognized by industry bodies, technology partners, and government
            institutions for our commitment to innovation and service quality.
          </p>
        </div>

        <div className="home-recognitions__grid">
          {visibleAwards.map((award, index) => (
            <div className="recognition-card" key={award.id || index}>
              <span className="recognition-card__photo">
                <img
                  src={award.image}
                  alt={award.altText || award.title}
                  loading="lazy"
                  decoding="async"
                />
              </span>
              <h3 className="recognition-card__title">{award.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
